const locale = {
  next:'dashboard_tour.next_btn',
  close:'dashboard_tour.close_btn',
  back:'dashboard_tour.back_btn',
  last:'dashboard_tour.last_btn',
  skip:'dashboard_tour.skip_btn'
}

export const DashboardContainerSteps =  [
  {
    target: '#account-info',
    content:'dashboard_tour.step1',
    disableBeacon:true,
    placement:'left',
    locale
  },
  {
    target: '#feature-info',
    content:'dashboard_tour.step2',
    disableBeacon:true,
    placement:'right',
    locale
  },
  {
    target: '#timeline-info',
    content:'dashboard_tour.step3',
    disableBeacon:true,
    placement:'auto',
    locale
  },
  {
    target: '#config-info',
    content:'dashboard_tour.step4',
    disableBeacon:true,
    placement:'bottom',
    locale
  },
  
]